<template>
  <div class="distribution-location-bd ub">
    <div class="depatrment-wrap ubv">
      <h1>{{ $t('Common.com_location') }}</h1>
      <div style="padding: 24px 0">
        <search-input width="100%" :placeholder="$t('Common.com_location_name')" v-model="appKey" @fetch="filterLocation"></search-input>
      </div>
      <div class="ub-f1">
        <ul class="list">
          <li :class="[{ cur: locationData.locationId === item.locationId }]" v-for="(item, index) in locationFilter" :key="index" @click="handleNodeClick(item)" class="ub">
            <div class="box">
              <i class="icon icon-xiangmu"></i>
            </div>
            <div class="name line1 ub-f1">{{ item.locationName }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div style="width: 1px; background: #f0f0f0"></div>
    <div class="memeber-wrap ubv">
      <h1>{{ $t('Common.com_site') }}</h1>
      <div style="padding: 24px 0">
        <search-input width="100%" :placeholder="$t('Common.com_site_name')" v-model="appKey1" @fetch="getSiteList"></search-input>
      </div>
      <div class="ub-f1">
        <ul class="list">
          <li :class="[{ cur: siteData.siteId === item.siteId }]" v-for="(item, index) in siteFilter" :key="index" @click="handleSiteClick(item)" class="ub">
            <div class="box">
              <i class="icon icon-mianji" style="color: #93da49"></i>
            </div>
            <div class="name line1 ub-f1">{{ item.siteName||'-' }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div style="width: 1px; background: #f0f0f0"></div>
    <div class="ub-f1 device-wrap ubv">
      <location-device-item :location="locationData" :site="siteData"></location-device-item>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
// import customTree from '@/components/customTree.vue';
import locationDeviceItem from './children/location_device_item.vue';

// i18n-lang-component
export default {
  name: 'distribution_member',
  components: { locationDeviceItem },
  props: {
    propsLocationId: {
      type: [Number, String],
      default: '',
    },
    propsSiteId: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      appKey: '',
      appKey1: '',
      locationData: {},
      locationList: [],
      locationFilter: [],
      siteData: {},
      siteList: [],
      siteFilter: [],
    };
  },
  mounted() {
    this.getLocatonList();
  },
  methods: {
    // 获取项目列表
    getLocatonList: function () {
      this.$getJSON(apis.portalLocationList, {
        orgId: this.userInfo.rootOrgId,
      }).then((res) => {
        this.locationList = [{ locationId: 0, locationName: this.$t('distribution_location.wfpxmdjq') }, ...res.data];
        if (this.locationList.length) {
          const item = this.locationList.find(i => i.locationId === this.propsLocationId);
          if (item) {
            this.locationData = this.locationList.find(i => i.locationId === this.propsLocationId);
          } else {
            this.locationData = this.locationList[0];
          }

          this.handleNodeClick(this.locationData);
        }
        this.filterLocation();
      });
    },
    // 项目列表过滤
    filterLocation: function () {
      if (!this.appKey) {
        this.locationFilter = this.locationList;
        return;
      }
      this.locationFilter = this.locationList.filter(t => t.locationName.includes(this.appKey));
    },
    // 选中项目
    handleNodeClick: function (item) {
      this.locationData = item;
      this.getSiteList();
    },
    // 获取站点
    getSiteList: function () {
      this.siteData = {};
      this.$getJSON(apis.locationSiteList, {
        locationId: this.locationData.locationId,
      }).then((res) => {
        if (this.locationData.locationId === 0) {
          this.siteList = [];
        } else {
          this.siteList = res.data;
        }
        if (this.propsSiteId) {
          this.siteData = this.siteList.find(i => i.siteId === this.propsSiteId);
          this.handleSiteClick(this.siteData);
        }

        this.filterSite();
      });
    },
    // 站点列表过滤
    filterSite: function () {
      if (!this.appKey1) {
        this.siteFilter = this.siteList;
        return;
      }
      this.siteFilter = this.siteList.filter(t => t.siteName.includes(this.appKey1));
    },
    // 选中站点
    handleSiteClick: function (data) {
      this.siteData = { ...data };
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.distribution-location-bd {
  background-color: #ffffff;
  height: 750px;
  border-radius: 16px;
  .list > li {
    height: 40px;
    line-height: 39px;
    cursor: pointer;
    padding-right: 12px;
    border: 1px solid transparent;
    .box {
      width: 38px;
      text-align: center;
      color: $--color-primary;
      .icon {
        font-size: 16px;
      }
    }
    .name {
      color: $--color-text-regular;
      font-size: 14px;
    }
    &.cur {
      border: 1px solid $--color-primary;
      border-radius: 8px;
      box-sizing: border-box;
      background: #f8f9fa;
      .name {
        color: $--color-primary;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
  .depatrment-wrap {
    width: 324px;
    padding: 24px;
    & > h1 {
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .memeber-wrap {
    width: 324px;
    padding: 24px;
    & > h1 {
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .device-wrap {
    padding: 24px 24px 0;
  }
}
</style>
